import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites",
)({
  component: () => <Outlet />,
});
